export default __webpack_public_path__ + "static/media/event_sd_top_2.263a7939.jpg";